/**
 * Social Media PropTypes
 *
 * PropType definitions for social media links, icons, and network information.
 * Used in footer, contact pages, and social sharing components.
 *
 * @module propTypes/social
 */

import PropTypes from "prop-types";

/**
 * Social network icon shape
 * Represents an icon image for a social network
 *
 * @property {string} url - Icon image URL
 */
export const socialIconShape = PropTypes.shape({
  url: PropTypes.string.isRequired,
});

/**
 * Social network shape
 * Represents a social media platform with link and icon
 *
 * @property {string} platform - Platform name (e.g., "Facebook", "Instagram", "Twitter")
 * @property {string} url - Profile/page URL
 * @property {Object} icon - Platform icon image
 */
export const socialNetworkShape = PropTypes.shape({
  platform: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  icon: socialIconShape,
});
